import AlphaHelpers from '../../abstracts/classes/alpha-helpers'
import AlphaModule from '../../abstracts/classes/alpha-module'
import jQuery from 'jquery'
import responsiveBootstrapToolkit from 'responsive-toolkit'

export default class Viewport extends AlphaModule {
  constructor(...args) {
    super(...args)

    this._viewport = null
  }

  getName() {
    return 'viewport'
  }

  _onLoad() {
    super._onLoad()

    this._initResponsiveBootstrapToolkit()
  }

  _initResponsiveBootstrapToolkit() {
    this._viewport = responsiveBootstrapToolkit
    this._viewport.use('bootstrap-5', this._buildBreakpointsDetectionDivs())

    this.dispatchEvent('initialized', {
      viewport: this.getViewport()
    })

    this._handleViewportChanges()
  }

  _buildBreakpointsDetectionDivs() {
    const breakpoints = AlphaHelpers.getBreakpoints()
    const lastBpIndex = breakpoints.length - 1
    const bpData = {}

    breakpoints.forEach((currentBp, currentIndex) => {
      // determine which breakpoints muse be used for current step
      const classes = []
      const bpIndexesToUse = []
      bpIndexesToUse.push(0)
      switch (currentIndex) {
        case 0:
          bpIndexesToUse.push(currentIndex + 1)
          break
        case lastBpIndex:
          bpIndexesToUse.push(currentIndex)
          break
        default:
          bpIndexesToUse.push(currentIndex)
          bpIndexesToUse.push(currentIndex + 1)
          break
      }

      // build classes accordingly
      bpIndexesToUse.forEach((index) => {
        const bp = breakpoints[index]
        const displayType = currentIndex === index ? 'block' : 'none'
        const infix = AlphaHelpers.getBreakpointInfix(bp)

        classes.push(`d-${infix}${displayType}`)
      })

      bpData[currentBp] = jQuery(`<div class="${classes.join(' ')}"></div>`)
    })

    return bpData
  }

  _handleViewportChanges() {
    const viewport = this.getViewport()
    if (viewport) {
      const resizeThrottle = 50
      setTimeout(() => {
        jQuery(window).resize(
          viewport.changed(() => {
            // inform other components that viewport changed
            this.dispatchEvent('changed', {
              viewport
            })
          }, resizeThrottle)
        ).resize()
      })
    }
  }

  getViewport() {
    return this._viewport
  }
}
